import * as S from '@shared/components/accordions/accordion-label.styles';
import { limitNumberOfCharacters } from '@shared/utils/strings';
import TEST_IDS from '@shared/utils/_tests/testIds.constants';
import React from 'react';
import { AccordionItemTooltip } from '@shared/components/tooltips/accordion-item-tooltip/accordion-item-tooltip';

const MAX_LABEL_SIZE = 45;

export const levelLabel = (label: string, maxChar: number = MAX_LABEL_SIZE): JSX.Element => (
    <S.LevelLabel>
        {limitNumberOfCharacters(label, maxChar)}
    </S.LevelLabel>
);

export const subLevelLabel = (
    firstSubLabel: string,
    maxChar: number = MAX_LABEL_SIZE,
): JSX.Element => (
    <S.SubLevelLabel data-testid={TEST_IDS.ACCORDION.ACCORDION_FIRST_SUB_LABEL}>
        {limitNumberOfCharacters(firstSubLabel, maxChar)}
    </S.SubLevelLabel>
);

export const labelWithTooltip = (
    label: string,
    labelType: Function,
    showTooltip: boolean,
): JSX.Element => (
    (showTooltip && label.length >= MAX_LABEL_SIZE) ? (
        <AccordionItemTooltip
            label={label}
        >
            {() => labelType(label)}
        </AccordionItemTooltip>
    ) : labelType(label)
);
